import React from 'react';
import PropTypes from 'prop-types';
import CorrectIcon from '@common/images/correct-icon.svg';
import IncorrectIcon from '@common/images/incorrect-icon.svg';
import {Image} from '@learningblocks/shared-components';
import style from './style.module.scss';

const ANSWER_INCORRECT = 'incorrect answer';
const ANSWER_CORRECT = 'correct anser';

/**
 * FooterFeedback
 *  - The component that displays the feedback for Question in footer
 */
export function FooterFeedback({showFeedback, isCorrect, className}) {
  if (showFeedback) {
    let src = IncorrectIcon;
    let alt = ANSWER_INCORRECT;
    if (isCorrect) {
      src = CorrectIcon;
      alt = ANSWER_CORRECT;
    }
    return (
      <Image
        className={`${style.feedbackIcon} ${className}`}
        src={src}
        alt={alt}
      />
    );
  } else {
    return null;
  }
}

FooterFeedback.propTypes = {
  /**
   * Boolean value to display/hide the feedback
   */
  showFeedback: PropTypes.bool.isRequired,
  /**
   * Boolean specifying if submitted answer correct.
   */
  isCorrect: PropTypes.bool.isRequired,
  /**
   * It is used to receive style from outside of the component
   */
  className: PropTypes.string,
};
